import script from "./SingleQueueListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleQueueListComponent.vue?vue&type=script&setup=true&lang=js"

import "../css/style.css?vue&type=style&index=0&id=5c0edcc8&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0edcc8"]])

export default __exports__